var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-dialog',{ref:"dialog",attrs:{"full-width":"","full-height":""},on:{"hide":_vm.onDialogHide}},[_c('q-card',{staticClass:"q-dialog-plugin"},[_c('div',{staticClass:"column"},[(_vm.showCalendar)?_c('div',{staticClass:"col q-px-md q-py-xs"},[_c('ScheduleCalendar',{on:{"on-change":_vm.handlerSelect}})],1):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }